import { Button } from '@evaneos/b2b-ui/legacy';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { Add } from '../../../../../../design-system/Icons/Add';
import { calculateTotalAmountOfInstalment } from '../../../../../../resources/contract/operations';
import {
    ContractId,
    InstalmentViewModel,
    PaymentScheduleViewModel,
} from '../../../../../../resources/contract/types';

import { AddInstalmentModal } from './AddInstalmentModal';
import { ExistingInstalment } from './ExistingInstalment';
import s from './PaymentScheduleStep.module.css';

type Props = {
    contractId: ContractId;
    instalments: InstalmentViewModel[];
    name: 'depositInstalments' | 'balanceInstalments';
    type: 'deposit' | 'balance';
    currency?: string;
};

export const FilledInstalmentList = ({
    contractId,
    instalments,
    name,
    type,
}: Props): JSX.Element => {
    const { values } = useFormikContext<PaymentScheduleViewModel>();
    const [isModalOpened, setisModalOpened] = useState(false);

    return (
        <>
            <div className={s.totalPriceAndAddButton}>
                <h3>
                    <FormattedMessage id={`contract.payment_schedule.${name}.title`} />
                </h3>
                <div>
                    <p data-testid={`${name}-total-amount`}>
                        <FormattedNumber
                            value={calculateTotalAmountOfInstalment(instalments)}
                            style="currency"
                            currency={values.currency || 'EUR'}
                        />
                    </p>
                    <Button
                        priority="secondary"
                        type="button"
                        onClick={() => {
                            setisModalOpened(true);
                        }}
                        className={s.addInstalmentButton}
                    >
                        <Add color="var(--ink)" />
                        <FormattedMessage id={`contract.payment_schedule.${name}.add`} />
                    </Button>
                </div>
            </div>
            <div>
                <div className={s.headersTable}>
                    <p className="ink-light">
                        <FormattedMessage id="contract.instalment.labels.status" />
                    </p>
                    <p className="ink-light">
                        <FormattedMessage id="contract.instalment.labels.date" />
                    </p>
                    <p className="ink-light">
                        <FormattedMessage id="contract.instalment.labels.payer" />
                    </p>
                    <p className="ink-light">
                        <FormattedMessage id="contract.instalment.labels.amount" />
                    </p>
                </div>
                {instalments &&
                    instalments.length > 0 &&
                    instalments.map((instalment, index) => (
                        <ExistingInstalment
                            key={`${name}.${index}`}
                            index={`${name}.${index}`}
                            instalment={instalment}
                            currency={values.currency as string}
                            contractId={contractId}
                        />
                    ))}
            </div>
            <AddInstalmentModal
                contractId={contractId}
                isOpen={isModalOpened}
                close={() => setisModalOpened(false)}
                currency={values.currency as string}
                type={type}
            />
        </>
    );
};
